import React from 'react';

export const WeatherLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <rect width="512" height="512" rx="15%" fill="#4A90D9" />
      <circle cx="210" cy="200" r="60" fill="#FFD93D" />
      <path
        d="M210 120v-20M210 280v20M130 200h-20M290 200h20M153.4 143.4l-14.1-14.1M266.6 256.6l14.1 14.1M266.6 143.4l14.1-14.1M153.4 256.6l-14.1 14.1"
        stroke="#FFD93D"
        strokeWidth="12"
        strokeLinecap="round"
      />
      <path
        d="M340 320c33.1 0 60-26.9 60-60 0-29.8-21.7-54.5-50.2-59.2C343.5 168.3 316.8 144 284 144c-28.1 0-52.1 18.3-60.5 43.6-5.6-2.3-11.7-3.6-18.1-3.6-26.5 0-48 21.5-48 48s21.5 48 48 48h134.6z"
        fill="white"
        fillOpacity="0.95"
      />
      <path
        d="M180 370h160M200 400h120M220 430h80"
        stroke="white"
        strokeWidth="10"
        strokeLinecap="round"
        strokeOpacity="0.6"
      />
    </svg>
  </div>
);
